export const ISOTPPASSWORD = true;
export const SHOWSIGNUPREFERENCENAME = true;
export const BRANDLOGOFILENAME = 'brand_logo.svg';
export const SHOWSPLASHVIDEOSCREENMODALCONFIG = true;
export const SPLASHVIDEOURL = "https://www.youtube.com/embed/aVq3zHsjW-g?autoplay=1&controls=0&showinfo=0&disablekb=1&modestbranding=1&rel=0&start=0";
export const SHOWSIGNUPREFERENCENAMECOMPULSORY = false;
export const SCORELOGOFILENAME = 'score_logo.svg';
export const CaptchaAutoRefresh = false;
export const CaptchaExpiryDeductionSec = 20;
export const LoginAndRegisterHaveURL = false;
export const OTPVia = "mobile";